import { ExpressionResolverFn } from "../../core/types";
import { ExpressionResolverError } from "../errors";

class RegexResolverError extends ExpressionResolverError {
  constructor(message: string) {
    super(message);
    this.name = "RegexResolverError";
  }
}

export const regexValidator: ExpressionResolverFn = ({
  fieldValue,
  expression,
}) => {
  const { params } = expression;
  if (!params) {
    throw RegexResolverError.create("No parameters provided");
  }

  if ("expr" in params && "value" in params.expr) {
    const patternValue = params.expr.value;
    // Always convert pattern value to string to ensure consistent handling
    const stringPattern = String(patternValue);
    const regex = new RegExp(stringPattern);
    // Always convert field value to string to ensure consistent handling
    const fieldValueStr = String(fieldValue);
    return regex.test(fieldValueStr);
  }

  throw RegexResolverError.create("Missing expr or value in parameters");
};
